import { api } from "./api";

export const getProfileById = async (userId) => {
  try {
    const response = await api.get(`/user/userdetails/${userId}`);
    const user = response.data?.data;

    if (!user || !user.id) {
      throw new Error("Invalid or missing user");
    }
    return user;
  } catch (error) {
    return null;
  }
};
